export const changeQuizViewMode = (isViewMode) => {
    return (dispatch) => {
        return dispatch({
            type: 'CHANGE_QUIZ_MODE',
            payload: isViewMode
        });
    };
};
